import script from "./ConnectionSuccess.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConnectionSuccess.vue?vue&type=script&setup=true&lang=ts"

import "./ConnectionSuccess.vue?vue&type=style&index=0&id=940d74be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-940d74be"]])

export default __exports__